module.exports = __webpack_public_path__ + "img/shengxiao.af74d0fb.png";